import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("mna_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function saveToken(t) { localStorage.setItem("mna_token", t); }
export function clearToken() { localStorage.removeItem("mna_token"); }
export function getToken() { return localStorage.getItem("mna_token"); }
